import OnboardingService from '../../services/onboarding.service';

// Action type constants
export const ONBOARDING_FETCH_START = 'ONBOARDING_FETCH_START';
export const ONBOARDING_FETCH_SUCCESS = 'ONBOARDING_FETCH_SUCCESS';
export const ONBOARDING_FETCH_FAILURE = 'ONBOARDING_FETCH_FAILURE';

export const ONBOARDING_MARK_STEP_LOCAL = 'ONBOARDING_MARK_STEP_LOCAL';
export const ONBOARDING_MARK_WELCOME_SEEN = 'ONBOARDING_MARK_WELCOME_SEEN';
export const ONBOARDING_DISMISS_ALL_LOCAL = 'ONBOARDING_DISMISS_ALL_LOCAL';

export const ONBOARDING_OPEN_WELCOME_MODAL = 'ONBOARDING_OPEN_WELCOME_MODAL';
export const ONBOARDING_CLOSE_WELCOME_MODAL = 'ONBOARDING_CLOSE_WELCOME_MODAL';

export const ONBOARDING_START_TOUR = 'ONBOARDING_START_TOUR';
export const ONBOARDING_END_TOUR = 'ONBOARDING_END_TOUR';
export const ONBOARDING_SET_TOUR_STEP_INDEX = 'ONBOARDING_SET_TOUR_STEP_INDEX';

export const ONBOARDING_OPEN_CHECKLIST = 'ONBOARDING_OPEN_CHECKLIST';
export const ONBOARDING_CLOSE_CHECKLIST = 'ONBOARDING_CLOSE_CHECKLIST';

export const ONBOARDING_RESET = 'ONBOARDING_RESET';

// =====================================================================
// Thunks (HTTP)
// =====================================================================

export const fetchOnboardingProgress = () => async (dispatch) => {
    dispatch({ type: ONBOARDING_FETCH_START });
    try {
        const data = await OnboardingService.getMyProgress();
        dispatch({ type: ONBOARDING_FETCH_SUCCESS, payload: data });
        return data;
    } catch (err) {
        dispatch({ type: ONBOARDING_FETCH_FAILURE, error: err?.message || 'fetch failed' });
        return null;
    }
};

export const markStepCompleteRemote = (stepId) => async (dispatch) => {
    try {
        const data = await OnboardingService.markStepComplete(stepId);
        if (data) {
            dispatch({
                type: ONBOARDING_MARK_STEP_LOCAL,
                stepId: data.stepId,
                completedAt: data.completedAt,
            });
        }
        return data;
    } catch (err) {
        return null;
    }
};

export const markWelcomeSeen = () => async (dispatch) => {
    try {
        await OnboardingService.markWelcomeSeen();
    } catch (err) {
        // swallow — não impede UX. Tentar de novo no próximo login se persistir.
    }
    dispatch({ type: ONBOARDING_MARK_WELCOME_SEEN });
};

// Botao "Ja vi todos os passos" no checklist drawer.
// UX: dispatch local IMEDIATO (badge some, drawer fecha), HTTP em background.
// Se HTTP falhar, na proxima sessao o estado vem do backend (idempotente).
export const dismissAllOnboardingSteps = () => async (dispatch) => {
    dispatch({ type: ONBOARDING_DISMISS_ALL_LOCAL });
    try {
        await OnboardingService.dismissAll();
    } catch (_) {
        // swallow — UX nao bloqueia.
    }
};

// =====================================================================
// Local actions (sem HTTP)
// =====================================================================

// Usado pelo listener SignalR pra refletir progresso em tempo real
export const markStepCompletedFromHub = (stepId, completedAt, allStepsCompleted) => ({
    type: ONBOARDING_MARK_STEP_LOCAL,
    stepId,
    completedAt,
    allStepsCompleted,
});

export const openWelcomeModal = () => ({ type: ONBOARDING_OPEN_WELCOME_MODAL });
export const closeWelcomeModal = () => ({ type: ONBOARDING_CLOSE_WELCOME_MODAL });

export const startTour = (tourId) => ({ type: ONBOARDING_START_TOUR, tourId });
export const endTour = () => ({ type: ONBOARDING_END_TOUR });
export const setTourStepIndex = (index) => ({ type: ONBOARDING_SET_TOUR_STEP_INDEX, index });

export const openChecklist = () => ({ type: ONBOARDING_OPEN_CHECKLIST });
export const closeChecklist = () => ({ type: ONBOARDING_CLOSE_CHECKLIST });

export const resetOnboarding = () => ({ type: ONBOARDING_RESET });
